var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function getByteSize(num) {
  var out = num >> 3;
  if (num % 8 !== 0) out++;
  return out;
}

var BitField = /*#__PURE__*/function () {
  "use strict";

  function BitField() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var opts = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, BitField);

    var grow = opts != null && opts.grow;
    this.grow = grow && isFinite(grow) && getByteSize(grow) || grow || 0;
    this.buffer = typeof data === 'number' ? new Uint8Array(getByteSize(data)) : data;
  }

  _createClass(BitField, [{
    key: "get",
    value: function get(i) {
      var j = i >> 3;
      return j < this.buffer.length && !!(this.buffer[j] & 128 >> i % 8);
    }
  }, {
    key: "set",
    value: function set(i) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var j = i >> 3;

      if (b) {
        if (this.buffer.length < j + 1) {
          var length = Math.max(j + 1, Math.min(2 * this.buffer.length, this.grow));

          if (length <= this.grow) {
            var newBuffer = new Uint8Array(length);
            newBuffer.set(this.buffer);
            this.buffer = newBuffer;
          }
        } // Set


        this.buffer[j] |= 128 >> i % 8;
      } else if (j < this.buffer.length) {
        // Clear
        this.buffer[j] &= ~(128 >> i % 8);
      }
    }
  }]);

  return BitField;
}();

if (typeof module !== 'undefined') module.exports = BitField;